








































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { Yuyue, Hd, Dock, yun } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { upload } from '@/common/util/ossUploadService';
import validator, { formRules } from '@/common/util/validator';
import QRCode from 'qrcodejs2';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        DraggerImg,
    },
})
export default class queueManage extends Vue {
    public isDisabled: boolean = true;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public inquiryStatusType = enums.inquiryStatusType;
    public hdStauts = enums.yyStatusType;
    public waybillStatus = enums.wayBillStatusType;
    public labelPosition: string = 'right';
    public formRules = formRules;
    public expandType: boolean = false;
    public dialogVisible: boolean = false;
    public dialogVisible1: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.appointStartTime = value[0];
            this.searchValue.appointEndTime = value[1];
        } else {
            this.searchValue.appointStartTime = null;
            this.searchValue.appointEndTime = null;
        }
    }
    timelines: any = [];
    statusArr: any = [];
    public searchValue: any = {
        statusStr: '',
        wareHouseId: '',
        carrierOrderCode: '',
        carCode: '',
        driver: '',
        //预约时间 承运商
        appointStartTime: '',
        appointEndTime: '',
        carrierName: '',
        carrierId: '',
    };
    public tableData: Array<any> = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
    };
    public handleClose() {
        this.dialogVisible = false;
    }
    public handleClose1() {
        this.dialogVisible1 = false;
    }
    creatQrCode() {
        let d = document.getElementById('ylewcode');
        console.log('mounted-->', d);
        var qrcode = new QRCode(document.getElementById('ylewcode'), {
            text: this.base + '?id=' + '4444',
            width: 90,
            height: 90,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.L,
        });
    }
    showCode: boolean = false;
    showewcode(row) {
        this.showCode = true;
    }
    base: any = '';
    wareTypes: any = [];
    public created() {
        if (process.env.NODE_ENV == 'development') {
            this.base = 'https://test-msls.vip56.cn/#/h5';
        } else {
            this.base = 'https://test-msls.vip56.cn/#/h5';
        }
    }
    public mounted() {
        Yuyue.GetWareHouseList({ name: '', keeperName: '', enabled: true, skip: 0, count: -1 }).then((res) => {
            this.wareTypes = res.data;
            console.log('warehouse-->', this.wareTypes);
        });
        if (sessionStorage.getItem('msqueuemanage_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('msqueuemanage_searchValue'));
            this.timeList = [this.searchValue.appointStartTime, this.searchValue.appointEndTime];
            if (this.searchValue.statusStr) {
                this.statusArr = this.searchValue.statusStr.split(',');
            }
            this.searchPagin = sessionStorage.getItem('msqueuemanage_page')
                ? JSON.parse(sessionStorage.getItem('msqueuemanage_page'))
                : this.searchPagin;
            this.getInquiryList();
        } else {
            this.searchPagin = sessionStorage.getItem('msqueuemanage_page')
                ? JSON.parse(sessionStorage.getItem('msqueuemanage_page'))
                : this.searchPagin;
            this.getInquiryList();
        }
        //  setTimeout(() => {
        //     this.creatQrCode();
        // }, 2000);

        // Yuyue.GetTimesInfoList({wareHouseId:'',appointTime:''}).then(res=>{
        //     this.timelines = res.map(item=>{
        //         return {id:item.id,name:`${item.startTime}-${item.endTime}`}
        //     })
        // })
    }
    public async handleUpload(param, file, fileList) {
        console.log('toupload-->', param);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url);
            this.upics.push({ name: param.file.name, url: url });
            //this.pics.push(file)
            //this.$emit('setImage', param.file.name, url, param.file.uid);
        } else {
            this.$message.warning('图片上传失败!');
        }
    }
    public beforeAvatarUpload(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
    }
    handleRemove(file, fileList) {
        // this.pics=this.pics.filter(v=>{
        //     return v.uid!=file.uid;
        // })
        if (this.upics.includes(file)) {
            this.upics.splice(this.upics.indexOf(file), 1);
        }
        console.log(file, fileList);
        //this.$emit('deleteImage', file.name, file.uid, file.url);
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'clientOrderCode':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'consignee':
                {
                    this.searchValue.orderBy = '2';
                }
                break;
            case 'carriageWay':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
            case 'realDeliveryTime':
                {
                    this.searchValue.orderBy = '4';
                }
                break;
            case 'realArrivalTime':
                {
                    this.searchValue.orderBy = '5';
                }
                break;
            case 'carLengthEnumStr':
                {
                    this.searchValue.orderBy = '6';
                }
                break;
            case 'carrierOrderStatus':
                {
                    this.searchValue.orderBy = '7';
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = '8';
                }
                break;
        }
        this.getInquiryList();
    }
    public cid: any = '';
    public upics: any = [];
    public toEdit(row) {
        // this.$confirm('确认签收回单?', '回单签收', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // })
        //     .then(() => {

        //     })
        //     .catch(() => {});
        console.log('row', row);
        this.upics = [];
        // Hd.GetDetail(row.id).then((res)=>{
        //     this.upics = res.map(v=>{
        //         return {name:v.attachmentName,url:v.attachmentUrl}
        //     })
        //     console.log('yl-->',res,this.upics);
        // }).catch(()=>{});
        // this.cid = row.id;
        this.dialogVisible1 = true;
    }
    public getMore() {
        this.expandType = !this.expandType;
    }
    yypdDialog: any = false;
    yypdForm: any = {
        carrierOrderId: '',
        carrierOrderCode: '',
        carCode: '',
        driverName: '',
        driverPhone: '',
        wareHouse: '',
        yyTime: '',
        winptr: '',
    };
    toyy() {
        this.$refs['yypdForm']['validate']((valid) => {
            if (valid) {
                console.log('yypdForm-->', this.yypdForm);
                this.$confirm(`恭喜预约成功，请在${this.yypdForm.yyTime}  -    XX:XX签到取号，等待叫号，有序进厂！`).then((res) => {});
            }
        });
    }
    qd() {
        this.$confirm('确认承运车辆已经到达现厂，确认签到取号？').then((res) => {
            this.$message.success('取号成功!');
        });
    }
    callDialog: any = false;
    handlecallClose() {
        this.callDialog = false;
    }
    public callDialgForm: any = {
        id: '',
        yt: '',
    };
    public docks: any = [];
    //叫号
    public async call(row) {
        this.callDialog = true;
        if (this.$refs['callForm']) {
            (this.$refs['callForm'] as any).resetFields();
        }
        let res = await Dock.GetDockList({
            wareHouseId: row.wareHouseId,
            isEnabled: true,
            skip: 0,
            count: -1,
        });
        console.log('docks-->', res);
        this.docks = res.data;
        //当前仓库月台个数

        if (this.docks && this.docks.length == 1) {
            this.callDialgForm.id = row.id;
            this.callDialgForm.yt = this.docks[0].id;
        }
        if (this.docks && this.docks.length > 1) {
            this.callDialgForm.id = row.id;
            this.callDialgForm.yt = '';
        }

        // if(this.docks.length>1){
        //     this.callDialog = true;
        //     this.callDialgForm.id = row.id;
        //     this.callDialgForm.yt ="";
        //     if(this.$refs['callForm']){
        //         (this.$refs['callForm'] as any).resetFields();
        //     }
        // }else{
        //     let h = this.$createElement;
        //     this.$confirm('',{
        //         message:h('div',null, [
        //         h('span',{ style:'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;'}, [
        //             h('i',{ class:'iconfont icon-lingdang-xianxing',style:'color:#64a6ff;font-size:20px;margin-right:10px;' }),
        //             h('span',null,'确认叫号'),
        //         ]),
        //         h('p',{ style:'margin:10px 0 0 40px;' },[
        //             h('span',null,'是否确认'),
        //             h('span',{style:'color:#64a6ff'},'叫号'),
        //             h('span',null,'?')
        //         ])
        //     ]),
        //     }).then(res=>{
        //         Yuyue.call({id:row.id,dockId:this.docks && this.docks.length>0?this.docks[0].id:''}).then(res=>{
        //             this.$message.success('叫号成功!');
        //             this.getInquiryList();
        //         })
        //     })
        // }
    }
    public calld() {
        this.$refs['callForm']['validate']((valid) => {
            if (valid) {
                Yuyue.call({ id: this.callDialgForm.id, dockId: this.callDialgForm.yt }).then((res) => {
                    this.$message.success('叫号成功!');
                    this.callDialog = false;
                    this.getInquiryList();
                });
            }
        });
    }
    // 处理弹窗
    public dialogConfig = {
        title: '',
        show: false,
    }
    confirmClose() {
        this.dialogConfig = {
         title: '',
         show: false,
        };
    }
    confirmOk(){
      if(this.row1){
        Yuyue.bePresent(this.row1).then((res) => {
                this.$message.success('确认到厂成功!');
                this.getInquiryList();
        });
      }
      else if(this.row2){
        Yuyue.pass(this.row2).then((res) => {
                this.$message.success('确认过号成功!');
                this.getInquiryList();
            });
      }
      else {
        Yuyue.leavePresent(this.row3).then((res) => {
                this.$message.success('确认出厂成功!');
                this.getInquiryList();
        });
      }
      this.dialogConfig = {
        title:'',
        show:false
      }
    }
    //到厂
    public row1:string = ''
    public dc(row) {
        this.row1 = row.id
        this.dialogConfig = {
            title:'到厂',
            show:true
        }
        // let h = this.$createElement;
        // this.$confirm('', {
        //     message: h('div', null, [
        //         h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
        //             h('i', { class: 'iconfont icon-ico_yuyueguanli_jiedaiyuyue', style: 'color:#64a6ff;font-size:20px;margin-right:10px;' }),
        //             h('span', null, '确认到厂'),
        //         ]),
        //         h('p', { style: 'margin:10px 0 0 40px;' }, [
        //             h('span', null, '是否确认'),
        //             h('span', { style: 'color:#64a6ff' }, '到厂'),
        //             h('span', null, '?'),
        //         ]),
        //     ]),
        // }).then((res) => {
        //     Yuyue.bePresent(row.id).then((res) => {
        //         this.$message.success('确认到厂成功!');
        //         this.getInquiryList();
        //     });
        // });
    }
    //过号
    public row2:string = ''
    public gh(row) {
        this.row2 = row.id
        this.dialogConfig = {
            title:'过号',
            show:true
        }
        // let h = this.$createElement;
        // this.$confirm('', {
        //     message: h('div', null, [
        //         h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
        //             h('i', { class: 'iconfont icon-houzhenjiaohaox', style: 'color:#fc8d70;font-size:20px;margin-right:10px;' }),
        //             h('span', null, '确认过号'),
        //         ]),
        //         h('p', { style: 'margin:10px 0 0 40px;' }, [
        //             h('span', null, '是否确认'),
        //             h('span', { style: 'color:#fc8d70' }, '过号'),
        //             h('span', null, '?'),
        //         ]),
        //     ]),
        // }).then((res) => {
        //     Yuyue.pass(row.id).then((res) => {
        //         this.$message.success('确认过号成功!');
        //         this.getInquiryList();
        //     });
        // });
    }
    //出厂
    public row3:string = ''
    public cc(row) {
        this.row3 = row.id
        this.dialogConfig = {
            title:'出厂',
            show:true
        }
        // let h = this.$createElement;
        // this.$confirm('', {
        //     message: h('div', null, [
        //         h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
        //             h('i', { class: 'iconfont icon-xiangqingfanhui', style: 'color:#ffa44c;font-size:20px;margin-right:10px;' }),
        //             h('span', null, '确认出厂'),
        //         ]),
        //         h('p', { style: 'margin:10px 0 0 40px;' }, [
        //             h('span', null, '是否确认'),
        //             h('span', { style: 'color:#ffa44c' }, '出厂'),
        //             h('span', null, '?'),
        //         ]),
        //     ]),
        // }).then((res) => {
        //     Yuyue.leavePresent(row.id).then((res) => {
        //         this.$message.success('确认出厂成功!');
        //         this.getInquiryList();
        //     });
        // });
    }
    public async exportExcel() {
        this.searchValue.statusStr = this.statusArr.join();
        let data = await Hd.Export(this.searchValue);
        // if (data) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }

    public getInquiryList() {
        this.loading = true;
        this.searchValue.statusStr = this.statusArr.join();
        Yuyue.getList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
                //  if (this.searchPagin.currentPage > 1) {
                //     if (this.tableData.length == 0) {
                //         this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                //         this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                //     }
                // }
            })
            .catch((err) => {
                this.loading = false;
            });
    }

    //回单预览
    public ylPics: any = [];
    public yl(row) {}
    public searchFunc() {
        this.searchValue.statusStr = this.statusArr.join();
        sessionStorage.setItem('msqueuemanage_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('msqueuemanage_page', JSON.stringify(pagin));
        this.getInquiryList();
    }

    public viewInquiry(item) {
        sessionStorage.setItem('msqueuemanage_page', JSON.stringify(this.searchPagin));
        this.$router.push({
            path: '/InquiryDetail',
            query: {
                type: 'view',
                id: item.id,
            },
        });
    }
    public selectionRow = [] as any;
    public multipleSelection: any;
    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
        if (rows.length) {
            this.isDisabled = false;
        } else {
            this.isDisabled = true;
        }
    }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    selectList: any = [];
    async querySearchcys(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    selectCys(data) {
        this.searchValue.carrierId = data.id;
    }
    toDetail(row, type, index) {
        let bd = row.orderList.length > 1 ? true : false;
        if (type == 1) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    // id: row.id,
                    // name: 'detail',
                    // orderCnt:row.orderList.length,
                    // orderId:row.orderList[0].id
                    id: row.orderList[0].id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    orderId: row.id,
                    tab: 'second',
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/orderDetailgo',
                query: {
                    id: row.orderList[index].id,
                    name: 'detail',
                    from: 'receiptManager',
                    //orderCnt:row.orderList.length,
                    //orderId:row.orderList[0].id
                },
            });
        } else if (type == 3) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    id: row.id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    orderId: row.orderList[0].id,
                },
            });
        }
    }

    public handleDelete(data) {
        this.$confirm('确认删除该询价单?', '询价单删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {})
            .catch(() => {});
    }
    public handleFinal(data) {
        this.$confirm('确认终结该询价单?', '询价单终结', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {})
            .catch(() => {});
    }

    public handleCommand(command) {
        switch (command.command) {
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    public colData =
        JSON.parse(localStorage.getItem('queuelist')) && JSON.parse(localStorage.getItem('queuelist')).length == 12
            ? JSON.parse(localStorage.getItem('queuelist'))
            : [
                  { title: '预约状态', isShow: true, disabled: false },
                  { title: '排队号', isShow: true, disabled: false },
                  { title: '预约码', isShow: true, disabled: false },
                  { title: '预约时间', isShow: true, disabled: false },
                  { title: '签到时间', isShow: true, disabled: false },
                  { title: '仓库', isShow: true, disabled: false },
                  { title: '月台', isShow: true, disabled: false },
                  { title: '承运商', isShow: true, disabled: false },
                  { title: '运单编号', isShow: true, disabled: false },
                  { title: '车牌号', isShow: true, disabled: false },
                  { title: '司机', isShow: true, disabled: false },
                  { title: '手机号', isShow: true, disabled: false },
                  { title: '创建时间', isShow: true, disabled: false },
              ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('queuelist', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
            statusStr: '',
            wareHouseId: '',
            carrierOrderCode: '',
            carCode: '',
            driver: '',
            //预约时间 承运商
            appointStartTime: '',
            appointEndTime: '',
            carrierName: '',
            carrierId: '',
        };
        this.statusArr = [];
        this.timeList = [];
        this.searchFunc();
    }
    public onexceed() {
        this.$message.warning('最多上传20张!');
    }
    flexColumnWidth(str, tableData, flag = 'max') {
        console.log('tableData', tableData);
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return '150px';
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 150) {
            // 设置最小宽度
            flexWidth = 150;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
}
